import React from 'react';
import { goToPreviousStep, goToNextStep } from '@src/stores/newFlowStore';
import { areContactDetailsProvided } from '@src/utils/lorpContactDetailsUtil';
import { RETURN_METHOD } from '@src/constants/general';
import { setReturnShipments, useReturnStore } from '@src/stores/returnStore';
import { ReturnButtons } from '../shared/ReturnButtons';
import { ReturnHeaders } from '../shared/ReturnHeaders';
import LORPContactDetailsStep from './lorp-contact-details/LORPContactDetailsStep';

const LORPReturnMethodFlow = () => {
  const selectedItems = useReturnStore((state) => state.selectedItems);
  const returnShipments = useReturnStore((state) => state.returnShipments);
  const lorpShipments = returnShipments?.filter(
    (shipment) => shipment.shipmentType === 'PICKUP',
  );
  const displayedContactDetails = lorpShipments?.[0]?.lorpContactDetails;
  const lorpLineItems = selectedItems.filter(
    (item) => item.returnMethod === RETURN_METHOD.LORP,
  );
  const areContactDetailsValid = areContactDetailsProvided(
    displayedContactDetails,
  );

  const handleBackButton = () => {
    goToPreviousStep();
  };

  const handleContinueButton = () => {
    // copy address to all LORP shipments if there are multiple (in case user came back with an added LORP shipment)
    if (!returnShipments) return;
    setReturnShipments(
      returnShipments.map((shipment) => {
        if (shipment.shipmentType === 'PICKUP') {
          return {
            ...shipment,
            lorpContactDetails: displayedContactDetails,
          };
        }
        return shipment;
      }),
    );
    goToNextStep();
  };

  return (
    <div>
      <ReturnHeaders title="Review your contact details" />
      <>
        <LORPContactDetailsStep itemsToReturn={lorpLineItems} />
      </>
      <ReturnButtons
        proceedNext={handleContinueButton}
        proceedBack={handleBackButton}
        disabled={!areContactDetailsValid}
      />
    </div>
  );
};

export default LORPReturnMethodFlow;
